module.exports = "<div class=notes v-el:notes> <note v-for=\"note in filteredNotes\" :note=note v-on:click=selectNote(note)> </note> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notes/Index.vue
 ** module id = 82
 ** module chunks = 0
 **/